<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.text_456')}}</div>
    <div slot="body">
      <dialog-selected-tips :count="params.data.length" :action="$t('scope.text_456')" :name="$t('scope.text_265')" />
      <dialog-table :data="params.data" :columns="params.columns.slice(0, 3)" />
      <a-form
        :form="form.fc">
        <a-form-item :label="$t('scope.text_815')" v-bind="formItemLayout">
          <a-textarea v-decorator="decorators.reason" :placeholder="$t('scope.text_816')" :rows="4" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'CancleBillDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      decorators: {
        reason: [
          'reason',
          {
            rules: [
              { required: true, message: this.$t('scope.text_816') },
            ],
          },
        ],
      },
    }
  },
  created () {
    this.billM = new this.$Manager('billpays')
  },
  methods: {
    doCancle (data) {
      return this.billM.performAction({
        id: this.params.data[0].id,
        action: 'cancel',
        data,
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        await this.doCancle(values)
        this.loading = false
        this.cancelDialog()
        this.params.refresh()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
